import {query} from "@solidjs/router";
import api from "~/api/api";
import {getUser} from "~/api/auth";
import {SubscriptionResponse} from "@tag-tails/types";

export const getSubscription = query(async (): Promise<SubscriptionResponse | null | undefined> => {
    "use server"
    const user = await getUser()
    if (user) {
        try {
            const res = await api.get<SubscriptionResponse>(`/subscription/user/${user.id}`)
            return res.data
        } catch {
            return null
        }
    }
    return undefined
}, "subscription")
